const Index = () => import('./Admin.vue')
const Details = () => import('./Details.vue')
import Membership from './membership'
import Metrics from './metrics'

const Admin = { Index, Details, Membership, Metrics }

export default Admin
